import axiosInstance from '../../core/axiosConfig';

export interface MonthlyFeeDefault {
  currency: string;
  /** Null, gdy dla waluty nie ustawiono jeszcze kwoty. */
  monthlyFee: number | null;
}

export class MonthlyFeeDefaultService {
  list = async (): Promise<MonthlyFeeDefault[]> => {
    const response = await axiosInstance.get<MonthlyFeeDefault[]>('/admin/monthly-fee-defaults');
    return response.data;
  };

  update = async (currency: string, monthlyFee: number): Promise<MonthlyFeeDefault> => {
    const response = await axiosInstance.put<MonthlyFeeDefault>(
      `/admin/monthly-fee-defaults/${currency}`,
      {
        monthlyFee,
      },
    );
    return response.data;
  };
}
